import { OnboardingTitle } from '../../OnboardingLayout';

interface IWaitlistedStepProps {
  onBack: () => void;
}

const WaitlistedStep = ({ onBack }: IWaitlistedStepProps) => {
  return (
    <OnboardingTitle
      title="You're on the waitlist"
      subtitle="We'll notify you when your account is ready. Thanks for your interest."
      onBack={onBack}
    />
  );
};

WaitlistedStep.displayName = 'WaitlistedStep';

export default WaitlistedStep;
